import React from "react"
import { ShoppingBagIcon } from "@heroicons/react/24/outline"
import Button from "aldoo-ra/Button"
import { navigate } from "vike/client/router"
import useT from "../../hooks/useT"

/** Empty cart (fragment "shopping-cart-empty") */
export default function CartEmpty({ store }) {
  const t = useT()
  return (
    <div className="flex flex-col items-center justify-center gap-4 px-6 py-16 text-center" data-testid="cart-empty">
      <div className="bg-primary/10 rounded-full p-6">
        <ShoppingBagIcon className="w-12 h-12 text-primary" />
      </div>
      <h3 className="m-0 text-[22px] font-bold">{t`Your cart is empty`}</h3>
      <p className="m-0 text-text_secondary max-w-[320px]">{t`Looks like you haven't added anything to your cart yet.`}</p>
      <Button
        variant="secondary"
        onClick={() => {
          store.hideCart()
          navigate("/books")
        }}
      >
        {t`Start Shopping`}
      </Button>
    </div>
  )
}
